import {
    Backdrop,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogTitle,
} from "@mui/material";
import { useIsMutating } from "@tanstack/react-query";
import { useContext, useState } from "react";
import { AppContext } from "../../../AppContext";
import SimpleWidgetsHeader from "../../../components/SimpleWidgetsHeader/SimpleWidgetsHeader";
import SimpleWidgetsInput from "../../../components/SimpleWidgetsInput/SimpleWidgetsInput";
import { isRoleAdmin, isRolePos } from "../../../frappeConfig";
import {
    usePOSEntryCreateData,
    useSearchPOSOpening,
} from "../../../shared/hooks/usePOSData";
import { getCurrentDate } from "../../../utils/dateUtils";
import { useStyles } from "./styles";

const OpeningCreateDialog = ({ dialogOpen, onConfirm }) => {
    const classes = useStyles();

    const createPOSOpeningEntryMutation = usePOSEntryCreateData();
    const { refetch: refetchOpeneningEntries } = useSearchPOSOpening();

    const [openingBalance, setOpeningBalance] = useState("");

    const [confirmationDialog, setConfirmationDialog] = useState(false);

    const { globalState, userInfo, company, posProfile } =
        useContext(AppContext);

    const isMutatin = useIsMutating();

    const permessionAllowed =
        userInfo.name == "Administrator" ||
        isRolePos(userInfo.role_profile_name) ||
        isRoleAdmin(userInfo.role_profile_name);

    const handleChange = (value) => {
        if (/^[0-9]*$/.test(value)) {
            setOpeningBalance(value);
        }
    };

    const handleSave = (event) => {
        event.preventDefault();
        // Perform necessary actions with the form data
        setConfirmationDialog(false);

        let cashValue = 0.0;

        try {
            cashValue = Number(openingBalance);
            if (isNaN(cashValue) || cashValue <= 0) {
                cashValue = 0.0;
                // alert("Please enter a valid cash value greater than 0");
                return;
            }
        } catch (err) {
            alert("Please enter a valid cash value");
            return;
        }

        const loggedInUser = userInfo.name;

        const entryName = "new-pos-opening-entry-3";
        const childEntryName = "new-pos-opening-entry-detail-4";

        const another = {
            docstatus: 1,
            doctype: "POS Opening Entry",
            name: entryName,
            __islocal: 1,
            // "__unsaved": 0,
            owner: loggedInUser,
            status: "Open",
            posting_date: getCurrentDate(),
            set_posting_date: 0,
            company: company.company_name,
            balance_details: [
                {
                    docstatus: 2,
                    doctype: "POS Opening Entry Detail",
                    name: childEntryName,
                    __islocal: 1,
                    __unsaved: 1,
                    owner: loggedInUser,
                    opening_amount: cashValue,
                    parent: entryName,
                    parentfield: "balance_details",
                    parenttype: "POS Opening Entry",
                    idx: 1,
                    mode_of_payment: "Cash",
                },
            ],
            pos_profile: posProfile.name,
            period_start_date: getCurrentDate(),
            user: loggedInUser,
        };

        createPOSOpeningEntryMutation.mutate(
            {
                branchId: globalState.branchName,
                formData: another,
            },
            {
                onSuccess: () => {
                    refetchOpeneningEntries();
                    if (onConfirm) onConfirm();
                },
            }
        );
    };

    return (
        <Dialog className={classes.BackdropBlur} open={dialogOpen}>
            {isMutatin ? (
                <Backdrop open={true}>
                    {" "}
                    <CircularProgress />
                </Backdrop>
            ) : (
                <div className={classes.AddExtraWidget}>
                    {permessionAllowed ? (
                        <>
                            <div className={classes.AddPaymentWidget}>
                                <div
                                    className={
                                        classes.SmallTablePlaceholderWrapper
                                    }
                                >
                                    <SimpleWidgetsHeader title="INITIAL CASH VALUE" />
                                </div>
                                <div className={classes.Container}>
                                    <SimpleWidgetsInput
                                        value={openingBalance}
                                        onChange={handleChange}
                                        label="Cash Value"
                                        onKeyDown={(e) => {
                                            e.key === "Enter" &&
                                                setConfirmationDialog(true);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={classes.Actions}>
                                <Button
                                    onClick={() => setConfirmationDialog(true)}
                                >
                                    Save
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div className={classes.SmallTablePlaceholderWrapper}>
                            <SimpleWidgetsHeader title="POS IN NOT OPEN" />
                            <div className={classes.Container}>
                                Please Contact Casheir or Supervisor
                            </div>
                        </div>
                    )}
                </div>
            )}

            <Dialog
                open={confirmationDialog}
                onClose={() => setConfirmationDialog(false)}
                aria-labelledby="opening-balance-confirmation"
                aria-describedby="opening-balance-confirmation"
            >
                <DialogTitle id="alert-dialog-title">
                    {`Opening Balance : ${openingBalance}`}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={() => setConfirmationDialog(false)}>
                        Cancel
                    </Button>
                    <Button onClick={handleSave}>Confirm</Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
};

export default OpeningCreateDialog;
